<template>
  <div id="register" class="box">
    <form class="form-register" @submit.prevent="register">
      <h1 class="h3 mb-3 font-weight-normal title">Create Account</h1>
      <div class="has-text-danger" role="alert" v-if="registrationErrors">
        {{ registrationErrorMsg }}
      </div>
      <div class="mx-4">
        <label for="firstname" class="sr-only">First Name</label>
        <input
          type="text"
          id="username"
          class="input is-rounded mb-4"
          placeholder="First Name"
          v-model="user.firstName"
          required
          autofocus
        />
      </div>
      <div class="mx-4">
        <label for="lastname" class="sr-only">Last Name</label>
        <input
          type="text"
          id="username"
          class="input is-rounded"
          placeholder="Last Name"
          v-model="user.lastName"
          required
          autofocus
        />
      </div>

      <hr />
      <div class="mx-4">
        <label for="username" class="sr-only">Username</label>
        <input
          type="text"
          id="username"
          class="input is-rounded mb-4"
          placeholder="Username"
          v-model="user.username"
          required
          autofocus
        />
      </div>
      <div class="mx-4">
        <label for="password" class="sr-only">Password</label>
        <input
          type="password"
          id="password"
          class="input is-rounded mb-4"
          placeholder="Password"
          v-model="user.password"
          required
        />
        <input
          type="password"
          id="confirmPassword"
          class="input is-rounded mb-4"
          placeholder="Confirm Password"
          v-model="user.confirmPassword"
          required
        />
      </div>
      <div class="mx-4 has-text-right">
        <button class="button is-success is-rounded" type="submit">
          Create Account
        </button>
      </div>

      <div id="needAccount">
        <router-link :to="{ name: 'login' }">Have an account?</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import authService from "../services/AuthService";

export default {
  name: "register-page",
  data() {
    return {
      user: {
        username: "",
        password: "",
        confirmPassword: "",
        role: "user",
      },
      registrationErrors: false,
      registrationErrorMsg: "There were problems registering this user.",
    };
  },
  methods: {
    register() {
      if (this.user.password != this.user.confirmPassword) {
        this.registrationErrors = true;
        this.registrationErrorMsg = "Password & Confirm Password do not match.";
      } else {
        // TOMA leveraging the data object
        const registerObject = this.user;
        registerObject.username = registerObject.username.toLowerCase();
        // const registerObject = {
        //   username: this.user.username.toLowerCase(),
        //   password: this.user.password,
        //   confirmPassword: this.user.confirmPassword,
        //   role: this.user.role,
        // };
        authService
          .register(registerObject)
          .then((response) => {
            if (response.status == 201) {
              this.$router.push({
                path: "/login",
                query: { registration: "success" },
              });
            }
          })
          .catch((error) => {
            const response = error.response;
            this.registrationErrors = true;
            if (response.status === 400) {
              this.registrationErrorMsg = "Bad Request: Validation Errors";
            }
            if (response.status === 409) {
              this.registrationErrorMsg =
                "Username already in use, please try another.";
            }
          });
      }
    },
    clearErrors() {
      this.registrationErrors = false;
      this.registrationErrorMsg = "There were problems registering this user.";
    },
  },
};
</script>

<!-- <style> 
#register {
  margin-left: 75px;
}

form > label {
  display: block;
  margin-bottom: 5px;
}

form > input {
  margin-bottom: 10px;
}
form > button {
  display: block;
  margin-bottom: 10px;
}
#confirmPassword{
  margin-left: 25px;
}
#needAccount {
  margin-top: 2%;
}
</style>
-->